import md5 from "md5";
import CryptoJS from "crypto-js";
import { information } from "../information";

export const encrypt = (text) => { 
  const { key_free } = information;
  const md5Key = md5(key_free).toLowerCase();
  let cipherText = CryptoJS.AES.encrypt(text, md5Key).toString();
  return cipherText;
};

export const decrypt = (cipherText) => {
  const { key_free } = information;
  const md5Key = md5(key_free).toLowerCase();
  let bytes = CryptoJS.AES.decrypt(cipherText, md5Key);
  let originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};
